/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

var GetLicenseIdentifiers = require('../../license-dashboard/services/GetLicenseIdentifiers');
var GetLicenseDashboard = require('../../license-dashboard/services/GetLicenseDashboard');

var LicenseCertificationStatusChangeView = require('../views/LicenseCertificationStatusChangeView');

module.exports = function(entityId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetLicenseIdentifiers(licenseId), GetEntityIdentifiers(entityId), GetLicenseDashboard(licenseId))
    .done(function(licenseIdentifier, entityIdentifier, licenseDashboard) {
      NavUtils.navigate('ext/nondep/entity/' + entityId + '/license/' + licenseId + '/change-certification-status');
      Scaffold.content.show(
        new LicenseCertificationStatusChangeView({
          viewMode: 'ext',
          isReadOnly: false,
          model: new Backbone.Model({
            entityId: entityId,
            licenseId: licenseId,
            licenseIdentifier: licenseIdentifier,
            entityIdentifier: entityIdentifier,
            licenseDashboard: licenseDashboard,
            creditCounselorStatuses: licenseDashboard.creditCounselorStatuses
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
